import { useQuery } from "react-query";
import { getServiceType } from "api/queries/form"


export function useGetServiceType(params) {
    return useQuery(
        ["serviceType", params?.options],
        () => getServiceType(), {
        ...params?.options,
        staleTime: 1000 * 60 * 60 * 24 * 7 // cache 1 week
    });
}